import { Button, Col, Row } from 'react-bootstrap';
import { BsDownload } from 'react-icons/bs';
import { Card } from '../../../app/components/Card';
import { useProvider } from '../../../app/hooks/providers';
import { useDateFormatter } from '../../../app/hooks/use-date-formatter';
import { useDocumentTitle } from '../../../app/hooks/use-document-title';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Credentials = () => {
  useDocumentTitle('Provider Credentials');
  const { isProviderLoading, provider } = useProvider();
  const { formatDate } = useDateFormatter({ placeholder: 'N/A' });

  return (
    <Row>
      <Col xs={12} md={6} lg={6}>
        <Card.SubCard className="p-4 mb-4">
          <h5>Basic Info</h5>
          <Row>
            <Col xs={12} md={4} lg={4}>
              <Card.Info label="First Name" isLoading={isProviderLoading}>
                {provider?.first_name ? provider?.first_name : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Card.Info label="Last Name" isLoading={isProviderLoading}>
                {provider?.last_name ? provider?.last_name : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Card.Info label="Degree(s)" isLoading={isProviderLoading}>
                {provider?.degree ? provider?.degree.join(', ') : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Card.Info label="NPI" isLoading={isProviderLoading}>
                {provider?.npi ? provider?.npi : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Card.Info label="Birthday" isLoading={isProviderLoading}>
                {formatDate(provider?.birth_date)}
              </Card.Info>
            </Col>
            <Col xs={12} md={4} lg={4}>
              <Card.Info label="Gender" isLoading={isProviderLoading}>
                {provider?.gender ? window.GENDER[provider.gender] : 'N/A'}
              </Card.Info>
            </Col>
          </Row>
        </Card.SubCard>
      </Col>
      <Col xs={12} md={6} lg={6}>
        <Card.SubCard className="p-4 mb-4">
          <h5>Contact Info</h5>
          <Row>
            <Col xs={12} lg={12}>
              <Card.Info label="Email" isLoading={isProviderLoading}>
                {provider?.email ? (
                  <a href={`mailto:${provider?.email}`}>{provider?.email}</a>
                ) : (
                  'N/A'
                )}
              </Card.Info>
            </Col>
            <Row xs={12} lg={12}>
              <Col xs={12} lg={6}>
                <Card.Info label="Phone number" isLoading={isProviderLoading}>
                  {provider?.phone_number ? provider?.phone_number : 'N/A'}
                </Card.Info>
              </Col>
              <Col xs={12} lg={6}>
                <Card.Info label="Phone number alternative" isLoading={isProviderLoading}>
                  {provider?.phone_number_alternative ? provider?.phone_number_alternative : 'N/A'}
                </Card.Info>
              </Col>
            </Row>
          </Row>
        </Card.SubCard>
      </Col>
      <Col xs={12} md={6} lg={4}>
        <Card.SubCard className="p-4 mb-4">
          <h5>Address</h5>
          <Row>
            <Col xs={12} lg={12}>
              <Card.Info label="Street" isLoading={isProviderLoading}>
                {provider?.street_address ? provider?.street_address : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} lg={12}>
              <Card.Info label="City, State" isLoading={isProviderLoading}>
                {provider?.city ? provider?.city : 'N/A'}
                {', '}
                {provider?.state ? provider?.state : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} lg={12}>
              <Card.Info label="Zip Code" isLoading={isProviderLoading}>
                {provider?.zip_code ? provider?.zip_code : 'N/A'}
              </Card.Info>
            </Col>
          </Row>
        </Card.SubCard>
      </Col>
      <Col xs={12} md={6} lg={4}>
        <Card.SubCard className="p-4 mb-4">
          <h5>Birth Location</h5>
          <Row>
            <Col xs={12} lg={12}>
              <Card.Info label="City" isLoading={isProviderLoading}>
                {provider?.birth_city ? provider?.birth_city : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} lg={12}>
              <Card.Info label="State" isLoading={isProviderLoading}>
                {provider?.birth_state ? provider?.birth_state : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} lg={6}>
              <Card.Info label="Country" isLoading={isProviderLoading}>
                {provider?.birth_country ? provider?.birth_country : 'N/A'}
              </Card.Info>
            </Col>
          </Row>
        </Card.SubCard>
      </Col>
      <Col xs={12} md={6} lg={4}>
        <Card.SubCard className="p-4 mb-4">
          <h5>Military</h5>
          <Row>
            <Col xs={12} lg={12}>
              <Card.Info label="Status" isLoading={isProviderLoading}>
                {provider?.military_status
                  ? window.MILITARY_STATUS[provider?.military_status]
                  : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} lg={12}>
              <Card.Info label="Branch" isLoading={isProviderLoading}>
                {provider?.military_branch
                  ? window.MILITARY_BRANCH[provider.military_branch]
                  : 'N/A'}
              </Card.Info>
            </Col>
            <Col xs={12} lg={12}>
              <Card.Info label="DD214" isLoading={isProviderLoading}>
                {provider?.dd214 ? (
                  <Button
                    size="sm"
                    variant="outline-primary"
                    href={provider?.dd214}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BsDownload className="tw:inline" /> Download License
                  </Button>
                ) : (
                  'N/A'
                )}
              </Card.Info>
            </Col>
          </Row>
        </Card.SubCard>
      </Col>
    </Row>
  );
};
